<div class="subscription-container bg-color">
  <div>
    <h2>{{ subscription.plan }}</h2>
    <p class="renewal-date"> {{  'translations' | translate:subscription.renewalDate }}</p>
  </div>
    <button mat-button (click)="manageSubscription()">{{'manage' | translate}}</button>
</div>